import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { DialogFormLeads } from "./DialogFormLeads";
import { Board } from "./Board";
import { Tasks } from "./Tasks";
import { useCrm } from "../../../hooks/useCrm";
import { Filters } from "./Filters";
import { ButtonsCreate } from "../../reusableUI/v2UI/ButtonsCreate";
import { Plus } from "lucide-react";
import { Buscar } from "./Buscar";
import { CrmIndicators } from './CrmIndicators';
import { useCrmIndicators } from '../../../hooks/useCrmIndicators';
import { filterIndicatorBoard, indicatorIds, indicatorDropIndex } from '../../../helpers/crmIndicators';
import { CommercialStateDialog } from './CommercialState';
import { useCrmCommercialState } from '../../../hooks/useCrmCommercialState';
import { toast } from 'react-toastify';

// import { Kanban } from '../dndKitExample/Kanban'
// import { KanbanCRM } from '../dndKitExample/KanbanCRM'

export const OportunidadesHome = () => {
  const {
    leads,
    optionView,
    setOptionView,

    loading,
    openDialog,
    setOpenDialog,

    leadForm,
    catalogs,
    funnels,
    filters,
    handleFilters,

    openCreateLead,
    openEditLead,
    handleEditById,

    updateForm,
    saveLead,
    moveLead,
    reorderLead,
    savingLeads,
    retryMove,
    funnelId,
    selectFunnel,
    dataRevision,
    refreshIndicators,
    applyCommercialResult,
    reloadLeads,
  } = useCrm();

  const [search, setSearch] = useState("");
  const [selection, setSelection] = useState(null);
  const [period, setPeriod] = useState('all');
  const [showAnalysis, setShowAnalysis] = useState(false);
  const commercial = useCrmCommercialState({ onSaved: applyCommercialResult });
  const requestCommercialChange = (lead, status) => {
    if (savingLeads?.[lead.id]) { toast.info('Guarda o reintenta el movimiento de esta tarjeta antes de cerrarla.'); return; }
    commercial.begin(lead, status);
  };
  const currencySymbol = useSelector(state => state.general.info.local_simbolo);
  const indicators = useCrmIndicators({ funnelId, text: filters.text, prospectType: filters.id_tipo, revision: dataRevision, period });
  const visibleLeads = filterIndicatorBoard(leads, indicatorIds(indicators.data, selection));
  const selectedCurrency = selection?.key === 'open' ? indicators.data?.open.currencies.find(item => String(item.id) === String(selection.currencyId)) : null;
  const chooseIndicator = (next, toggle = true) => {
    if (toggle && selection?.key === next.key && String(selection?.currencyId) === String(next.currencyId)) { setSelection(null); return; }
    setSelection(next);
    setOptionView('board');
    const desiredStatus = next.key === 'closed' ? '' : 'activo';
    if (filters.estado !== desiredStatus) handleFilters({ target: { name: 'estado', value: desiredStatus } });
    const desiredCommercial = next.key === 'closed' ? '' : 'abierta';
    if (filters.estado_comercial !== desiredCommercial) handleFilters({ target: { name: 'estado_comercial', value: desiredCommercial } });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const filterText = {
        target: {
          name: "text",
          value: search,
        },
      };

      handleFilters(filterText);
    }, 300);

    return () => clearTimeout(timer);
  }, [search, handleFilters]);

  return (
    <div className="p-container">
      <CommercialStateDialog state={commercial} stages={leads} onRefresh={() => { commercial.close(); setOpenDialog(false); reloadLeads(); refreshIndicators(); }} />
      {openDialog ? (
        <DialogFormLeads
          form={leadForm}
          open={openDialog}
          setOpen={setOpenDialog}
          funnels={leads.filter(stage => !['ganado', 'perdido'].includes(stage.tipo) || String(stage.id) === String(leadForm.id_etapa))}
          tiposProspectos={catalogs.tiposProspectos}
          listaClasificacionTask={catalogs.clasificaciones}
          listaOrigen={catalogs.origenes}
          saveLead={saveLead}
          updateForm={updateForm}
          loading={loading}
          onCommercialChange={requestCommercialChange}
          commercialBusy={commercial.saving || Boolean(savingLeads?.[leadForm.id])}
        />
      ) : (
        ""
      )}

      <h1 className="text-[22px] mt-[10px] ms-[10px] text-[#595759]">
        Oportunidades
      </h1>

      <select aria-label="Embudo comercial" className="mt-2 ms-2" value={funnelId || ''} onChange={event => { setSelection(null); selectFunnel(event.target.value); }}>
        {funnels.map(it => <option key={it.id} value={it.id}>{it.nombre}</option>)}
      </select>

      <div className="flex flex-col md:flex-row justify-content-between">
        <div className="mt-4 p-box-menu-tab">
          <Link
            to=""
            className={`${optionView === "board" ? "selected" : ""}`}
            onClick={() => setOptionView("board")}
          >
            Tablero
          </Link>
          <Link
            to=""
            className={`${optionView === "tasks" ? "selected" : ""} ms-2`}
            onClick={() => setOptionView("tasks")}
          >
            Actividades programadas
          </Link>
          {/* <Link to="" className={`${optionView === 'pptos' ? 'selected' : ''} ms-2`} onClick={() => setOptionView('pptos')}>Presupuestos</Link> */}
        </div>

        <ButtonsCreate
          icon={<Plus size={16} />}
          name="Nueva oportunidad"
          handleClick={openCreateLead}
        />
      </div>

      <div className="flex mt-3 ms-1 bg-white p-3 rounded-lg">
        <Filters
          filters={filters}
          handleFilters={event => { setSelection(null); handleFilters(event); }}
          tiposProspectos={catalogs.tiposProspectos}
          listaClasificacionTask={catalogs.clasificaciones}
          listaOrigen={catalogs.origenes}
        />
        <div className="ms-2">
          <Buscar search={search} setSearch={value => { setSelection(null); setSearch(value); }} />
        </div>
      </div>

      {optionView === 'board' && <section aria-label="Resumen de seguimiento" aria-busy={indicators.loading} className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-3 px-3 py-2 rounded-lg bg-[#faf0e8] text-xs text-gray-600">
        <span className="font-medium text-[#595759]">Seguimiento</span>
        {indicators.error ? <span role="status">Seguimiento no disponible. <button type="button" onClick={indicators.refresh} className="underline">Reintentar</button></span> : <>
          <button type="button" disabled={!indicators.data || indicators.loading} aria-pressed={selection?.key === 'overdue'} onClick={() => chooseIndicator({ key: 'overdue' })} className="text-orange-700 underline disabled:opacity-50">{indicators.data?.attention.overdue ?? '—'} con actividades vencidas</button>
          <button type="button" disabled={!indicators.data || indicators.loading} aria-pressed={selection?.key === 'no_next'} onClick={() => chooseIndicator({ key: 'no_next' })} className="underline disabled:opacity-50">{indicators.data?.attention.no_next ?? '—'} sin próxima actividad</button>
        </>}
        <button type="button" aria-expanded={showAnalysis} aria-controls="crm-analysis" onClick={() => setShowAnalysis(value => !value)} className="text-purple-700 underline md:ml-auto">{showAnalysis ? 'Cerrar análisis' : 'Ver análisis'}</button>
      </section>}
      {optionView === 'board' && <div id="crm-analysis" hidden={!showAnalysis}>
        <CrmIndicators {...indicators} selection={selection} onSelect={chooseIndicator} fallbackSymbol={currencySymbol} period={period} onPeriodChange={setPeriod} />
      </div>}
      {optionView === 'board' && selection && <div className="flex items-center justify-between mt-3 px-3 py-2 rounded-lg bg-purple-50 text-sm text-purple-800">
        <span>{({ open: 'Oportunidades abiertas de la moneda seleccionada', closed: 'Oportunidades ganadas y perdidas · incluye archivadas', attention: 'Oportunidades que necesitan seguimiento', overdue: 'Oportunidades con actividades vencidas', no_next: 'Oportunidades sin próxima actividad' })[selection.key]}</span>
        <button type="button" className="underline ml-3" onClick={() => setSelection(null)}>Quitar filtro del indicador</button>
      </div>}

      {/* <Kanban /> */}
      {/* <KanbanCRM /> */}

      {optionView === "board" ? (
        selection && !indicators.data ? <p role="status" className="mt-4 text-sm text-gray-500">{indicators.error ? 'Reintenta los indicadores para consultar estas oportunidades.' : 'Actualizando oportunidades del indicador…'}</p> :
        <Board leads={visibleLeads.filter(stage => !['ganado', 'perdido'].includes(stage.tipo) || stage.leads.length)} onCommercialChange={requestCommercialChange} summarySymbol={selectedCurrency?.symbol} openEditLead={openEditLead} moveLead={(lead, stageId, index) => moveLead(lead, stageId, selection ? indicatorDropIndex(leads, visibleLeads, lead.id, stageId, index) : index)} reorderLead={reorderLead} savingLeads={savingLeads} retryMove={retryMove} />
      ) : (
        ""
      )}

      {optionView === "tasks" ? (
        <Tasks handleEditById={handleEditById} filtersCrm={filters} onTasksChanged={refreshIndicators} />
      ) : (
        ""
      )}
    </div>
  );
};
